import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './ReportHeader.module.scss';
const extractDatePart = (value) => {
    if (!value)
        return null;
    const isoDateMatch = /^(\d{4}-\d{2}-\d{2})/.exec(value);
    if (isoDateMatch) {
        return isoDateMatch[1];
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }
    return parsed.toISOString().split('T')[0];
};
const ReportHeader = ({ studyDate, testType, interpreter, referrer, updatedDate }) => {
    const { t } = useTranslation();
    const formattedUpdatedDate = extractDatePart(updatedDate);
    return (_jsxs(Box, { className: styles.report_header, children: [_jsx(Box, { className: styles.title_row, children: _jsxs(Typography, { sx: {
                        fontFamily: 'Plus Jakarta Sans, sans-serif',
                        fontWeight: 600,
                        fontSize: '18px',
                        lineHeight: '32px',
                        color: '#0d0a15'
                    }, children: [t('REPORT_HEADER.TITLE'), formattedUpdatedDate && ` (${t('REPORT_HEADER.UPDATED_LABEL')} ${formattedUpdatedDate})`] }) }), _jsxs(Box, { className: styles.study_info_container, children: [_jsxs(Box, { className: styles.info_row, children: [studyDate && (_jsxs(Box, { className: styles.info_item, children: [_jsx("span", { className: styles.info_label, children: t('REPORT_HEADER.STUDY_DATE_LABEL') }), _jsx("span", { className: styles.info_value, children: studyDate })] })), testType && (_jsxs(Box, { className: styles.info_item, children: [_jsx("span", { className: styles.info_label, children: t('REPORT_HEADER.TEST_TYPE_LABEL') }), _jsx("span", { className: styles.info_value, children: testType })] }))] }), _jsxs(Box, { className: styles.info_row, children: [interpreter && (_jsxs(Box, { className: styles.info_item, children: [_jsx("span", { className: styles.info_label, children: t('REPORT_HEADER.INTERPRETER_LABEL') }), _jsx("span", { className: styles.info_value, children: interpreter })] })), referrer && (_jsxs(Box, { className: styles.info_item, children: [_jsx("span", { className: styles.info_label, children: t('REPORT_HEADER.REFERRER_LABEL') }), _jsx("span", { className: styles.info_value, children: referrer })] }))] })] })] }));
};
export default ReportHeader;
